import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import StarUpdateListLayer from "../components/StarUpdateListLayer";

const StarUpdatePage = () => {
  return (
    <MasterLayout>
      <StarUpdateListLayer />
    </MasterLayout>
  );
};

export default StarUpdatePage;
